<template>
  <v-layout column>
    <v-layout row reverse class="mb-2">
      <v-flex shrink align-self-start>
        <v-btn
          :to="{
            name: 'locationNew',
            query: { clientBusinessId: this.clientBusiness.id }
          }"
          color="success"
        >
          <v-icon left>
            add
          </v-icon>
          Add Location
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex
        xs4
        class="mb-2"
        :key="location.id"
        v-for="location in orderedLocations"
      >
        <v-layout row>
          <v-flex shrink>
            <v-icon
              @click="editingId = location.id"
              v-if="editingId != location.id"
            >
              create
            </v-icon>
            <v-icon v-if="editingId == location.id" @click="editingId = null">
              close
            </v-icon>
            <InternalNotesWidget
              v-if="user.managerOrHigher"
              entityName="Worksite"
              :entityId="location.id"
              unfixed="true"
              small
            />
          </v-flex>
          <v-flex v-if="editing(location.id)">
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="name"
              :storeFieldValue="location.name"
              label="Name"
            >
            </ApiField>
            <ApiField
              fieldType="autocomplete"
              :items="possibleManagers"
              itemText="name"
              itemValue="id"
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="manager_id"
              :storeFieldValue="location.managerId"
              label="Manager"
            >
            </ApiField>
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="street_address"
              :storeFieldValue="location.streetAddress"
              label="Street Address"
            >
            </ApiField>
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="city"
              :storeFieldValue="location.city"
              label="City"
            >
            </ApiField>
            <ApiField
              fieldType="autocomplete"
              :items="states"
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="state"
              :storeFieldValue="location.state"
              label="State"
            >
            </ApiField>
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="zip"
              :storeFieldValue="location.zip"
              label="Zip"
            >
            </ApiField>
            <ApiField
              fieldType="textarea"
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="map_embed"
              :storeFieldValue="location.mapEmbed"
              label="Google Maps iFrame Embed Code"
            >
            </ApiField>
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="phone"
              :storeFieldValue="location.phone"
              label="Phone"
            >
            </ApiField>
            <ApiField
              fieldType="textarea"
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="scope"
              :storeFieldValue="location.scope"
              label="Scope"
            >
            </ApiField>
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="management_software"
              :storeFieldValue="location.managementSoftware"
              label="Hospital Management Software"
            >
            </ApiField>
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="dvm_count"
              :storeFieldValue="location.dvmCount"
              label="DVMs"
            >
            </ApiField>
            <!--
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="timeclock_location"
              :storeFieldValue="location.timeclockLocation"
              label="Location of Timeclock"
            >
            </ApiField>
            -->
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="uniform_requirements"
              :storeFieldValue="location.uniform_requirements"
              label="Uniform Requirements"
            >
            </ApiField>
            <ApiField
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="website"
              :storeFieldValue="location.website"
              label="Website"
            >
            </ApiField>
            <ApiField
              fieldType="textarea"
              rows="10"
              storeAction="clientBusinesses/locationUpdate"
              storeUpdate="clientBusinesses/refreshLocation"
              paramName="worksite"
              :object="location"
              fieldName="overview"
              :storeFieldValue="location.overview"
              label="Overview"
            >
            </ApiField>
          </v-flex>
          <v-flex class="px-2" v-else>
            <div class="mb-3">
              <p class="mb-0">
                <span class="all-caps body-2">
                  <LocationName :location="location" showColor />
                </span>
                <v-layout column class="my-2">
                  <v-flex v-for="s in location.segments">
                    <GeoTag :geotag="s" :show-worksites="false" />
                  </v-flex>
                </v-layout>
                <span class="subheading"
                  ><span class="font-weight-bold">Manager:</span>
                  {{
                    location.managerName ? location.managerName : "No manager!"
                  }}</span
                ><br />
                {{ location.streetAddress }}<br />
                {{ location.city }}, {{ location.state }} {{ location.zip }}
              </p>

              <div v-if="location.mapEmbed">
                <v-dialog v-model="mapDialog">
                  <a slot="activator" href="#">Show map</a>
                  <v-card class="text-xs-center">
                    <v-card-text>
                      <div v-html="location.mapEmbed"></div>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
            </div>
            <p v-if="location.phone">
              <span class="all-caps body-2">Phone: </span>{{ location.phone }}
            </p>
            <!--
            <v-img v-if="location.officeImageUrl" class="mb-3":src="location.officeImageUrl"></v-img>
            -->
            <ul class="info-listing mb-3">
              <li v-if="location.scope">
                <span>Scope: </span>{{ location.scope }}
              </li>
              <li v-if="location.managementSoftware">
                <span>Hospital Management Software: </span
                >{{ location.managementSoftware }}
              </li>
              <li v-if="location.dvmCount">
                <span>DVMs: </span>{{ location.dvmCount }}
              </li>
              <!-- <li v-if="location.timeclockLocation"><span>Location of Timeclock: </span>{{ location.timeclockLocation }}</li> -->
              <li v-if="location.uniformRequirements">
                <span>Uniform Requirements: </span
                >{{ location.uniformRequirements }}
              </li>
              <li v-if="location.website">
                <span>Website: </span
                ><a target="_blank" :href="location.website">{{
                  location.website
                }}</a>
              </li>
            </ul>
            <div v-if="location.overview">
              <span class="all-caps font-weight-bold">Overview: </span>
              <p style="white-space: pre-wrap;">{{ location.overview }}</p>
            </div>
            <div>
              <h2 class="subheading font-weight-bold">Client users:</h2>
              <div v-if="location.clients.length > 0">
                <ul>
                  <li v-for="client in location.clients">
                    <router-link
                      target="_blank"
                      :to="{
                        name: 'clientDetail',
                        params: { clientId: client.id }
                      }"
                      >{{ client.name }}</router-link
                    >
                    ({{ client.email }})
                  </li>
                </ul>
              </div>
              <div v-else>
                <p>
                  No client users at this location. Click on one in
                  <router-link :to="{ name: 'hrClients' }"
                    >the client index</router-link
                  >
                  and assign them to this location, or create a new client user:
                </p>
              </div>

              <v-btn
                class="mt-4"
                :to="{ name: 'clientNew', query: { worksiteId: location.id } }"
                color="success"
              >
                <v-icon left>
                  add
                </v-icon>
                Create Client User
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import collectionsApi from "@/api/collections";
import ApiField from "@/components/base/api-field.vue";
import LocationName from "@/components/hr/location-name.vue";
import GeoTag from "@/components/geotags/geo-tag.vue";

export default {
  props: ["clientBusiness"],
  components: {
    ApiField,
    GeoTag
  },
  computed: {
    ...mapState("userAuth", ["user"]),
    exampleComputed: function() {
      return this.example;
    },
    orderedLocations: function() {
      if (this.clientBusiness.locations) {
        return this.clientBusiness.locations
          .slice()
          .sort((a, b) => a.id - b.id);
      }
    }
  },
  created() {
    this.setUp();
  },
  watch: {},
  data: function() {
    return {
      editingId: null,
      possibleManagers: [],
      newManager: null,
      mapDialog: null,
      states: collectionsApi.getStates()
    };
  },
  methods: {
    editing(locationId) {
      if (this.editingId && this.editingId == locationId) {
        return true;
      }
    },
    setUp() {
      collectionsApi.getManagersList({}, managers => {
        this.possibleManagers = managers;
      });
    },
    updateLocation() {
      if (!this.newManager) {
        return;
      }
      this.$store.dispatch("clientBusinesses/update", {
        id: this.clientBusiness.id,
        client_business: {
          manager_id: this.newManager.id
        }
      });
    }
  }
};
</script>

<style scoped></style>
